module.exports = __webpack_public_path__ + "static/img/partner.37be0de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner.jpg
// module id = MzEu
// module chunks = 1